import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#111111] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="text-2xl font-bold mb-4">
              <span className="text-white">Gran</span>
              <span className="text-[#FF3366]">Tour</span>
              <span className="text-white">360</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Onde cada detalhe convida a entrar. Tours Virtuais 360° que transformam curiosidade em decisão.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navegação</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/60 text-sm hover:text-[#FF3366] transition-colors" data-testid="footer-link-home">Início</Link></li>
              <li><Link to="/portfolio" className="text-white/60 text-sm hover:text-[#FF3366] transition-colors" data-testid="footer-link-portfolio">Portfólio</Link></li>
              <li><Link to="/servicos" className="text-white/60 text-sm hover:text-[#FF3366] transition-colors" data-testid="footer-link-services">Serviços</Link></li>
              <li><Link to="/sobre" className="text-white/60 text-sm hover:text-[#FF3366] transition-colors" data-testid="footer-link-about">Sobre Nós</Link></li>
              <li><Link to="/blog" className="text-white/60 text-sm hover:text-[#FF3366] transition-colors" data-testid="footer-link-blog">Blog</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Serviços</h3>
            <ul className="space-y-3">
              <li className="text-white/60 text-sm">Tours Imobiliários</li>
              <li className="text-white/60 text-sm">Hotéis e Pousadas</li>
              <li className="text-white/60 text-sm">Salões de Festas</li>
              <li className="text-white/60 text-sm">Restaurantes</li>
              <li className="text-white/60 text-sm">Escolas</li>
              <li className="text-white/60 text-sm">Concessionárias</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-white/60 text-sm">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <span>contato@grantour360.com.br</span>
              </li>
              <li className="flex items-start gap-3 text-white/60 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span>(41) 99945-5042</span>
              </li>
              <li className="flex items-start gap-3 text-white/60 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Curitiba - PR, Brasil</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="#" className="text-white/60 hover:text-[#FF3366] transition-colors" aria-label="Instagram" data-testid="social-instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex justify-center items-center">
          <p className="text-white/40 text-sm">
            &copy; {currentYear} Gran Tour 360. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
